import type {
  GetDataAccessRequestVerificationAttachmentSignedUrlParams,
  GetDataAccessRequestsVerificationParams
} from 'services/data-access-requests/types'

export const DataAccessRequestQueryKeys = {
  All: () => ['data-access-requests'],
  Verification: (requestId: string) => [...DataAccessRequestQueryKeys.All(), 'verification', requestId],
  VerificationList: (params: GetDataAccessRequestsVerificationParams) => [
    ...DataAccessRequestQueryKeys.All(),
    'verification-list',
    params
  ],
  FilterLabels: () => [...DataAccessRequestQueryKeys.All(), 'filter-labels'],
  FilterUsers: () => [...DataAccessRequestQueryKeys.All(), 'filter-users'],
  FilterAssignees: () => [...DataAccessRequestQueryKeys.All(), 'filter-assignees'],
  FilterWorkspaces: () => [...DataAccessRequestQueryKeys.All(), 'filter-workspaces'],
  AssignableAssignees: (requestId: string) => [...DataAccessRequestQueryKeys.All(), 'assignable-assignees', requestId],
  StudyIdEvaluation: (requestId: string, studyId: string) => [
    ...DataAccessRequestQueryKeys.All(),
    'study-id-evaluation',
    requestId,
    studyId
  ],
  RelatedRequests: (groupId: string) => [...DataAccessRequestQueryKeys.All(), 'related-requests', groupId],
  VerificationAttachmentSignedUrl: (params: GetDataAccessRequestVerificationAttachmentSignedUrlParams) => [
    ...DataAccessRequestQueryKeys.All(),
    'verification-attachment-signed-url',
    params
  ]
}
